import { render, staticRenderFns } from "./uploadOtherDocument.vue?vue&type=template&id=754653e3&scoped=true&"
import script from "./uploadOtherDocument.vue?vue&type=script&lang=js&"
export * from "./uploadOtherDocument.vue?vue&type=script&lang=js&"
import style0 from "./uploadOtherDocument.vue?vue&type=style&index=0&id=754653e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754653e3",
  null
  
)

export default component.exports